var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.7959C5.5332 3.7959 3.9375 5.42871 3.9375 7.3584C3.9375 9.3252 5.5332 10.9209 7.5 10.9209C9.42969 10.9209 11.0625 9.3252 11.0625 7.3584C11.0625 5.42871 9.42969 3.7959 7.5 3.7959ZM7.5 9.7334C6.16406 9.7334 5.125 8.69434 5.125 7.3584C5.125 6.05957 6.16406 4.9834 7.5 4.9834C8.79883 4.9834 9.875 6.05957 9.875 7.3584C9.875 8.69434 8.79883 9.7334 7.5 9.7334ZM7.5 0.233398C3.5293 0.233398 0.375 3.4248 0.375 7.3584C0.375 10.2529 1.33984 11.0693 6.75781 18.8623C7.0918 19.3818 7.87109 19.3818 8.20508 18.8623C13.623 11.0693 14.625 10.2529 14.625 7.3584C14.625 3.4248 11.4336 0.233398 7.5 0.233398ZM7.5 17.8232C2.30469 10.3643 1.5625 9.77051 1.5625 7.3584C1.5625 5.7998 2.15625 4.31543 3.26953 3.16504C4.41992 2.05176 5.9043 1.4209 7.5 1.4209C9.05859 1.4209 10.543 2.05176 11.6934 3.16504C12.8066 4.31543 13.4375 5.7998 13.4375 7.3584C13.4375 9.77051 12.6582 10.3643 7.5 17.8232Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.deacef74.svg";
export { ForwardRef as ReactComponent };